import { SelectField } from '~/common/components';
import { SelectErrorIndicator, SelectLoadingIndicator } from '@wyz/ui';
import { Trans, useI18n } from '~/common/context';
import { useManageEcotaxesZones } from '~/connect/api';
import * as React from 'react';

type SelectEcotaxZones = {
  name: string;
  label: React.ReactNode;
  required?: boolean;
  isClearable?: boolean;
  readOnly?: boolean;
  countryId?: number;
};

export const SelectEcotaxZones = ({
  name,
  label,
  isClearable,
  required = false,
  readOnly,
  countryId,
}: SelectEcotaxZones) => {
  const ecotaxesZones = useManageEcotaxesZones({
    getAll: { args: { countryId } },
  });
  const { t } = useI18n();
  return (
    <>
      {(ecotaxesZones.isError || !countryId) && (
        <SelectErrorIndicator
          label={label}
          message={
            !countryId ? (
              <Trans i18nKey='app.common.select_field.country_not_select' />
            ) : (
              <Trans i18nKey='app.common.select_field.options_error' />
            )
          }
        />
      )}
      {!ecotaxesZones.isSettled && Boolean(countryId) && (
        <SelectLoadingIndicator label={label} />
      )}
      {ecotaxesZones.isSuccess && (
        <SelectField
          name={name}
          label={label}
          options={ecotaxesZones?.data?.data.map((ecotaxZone) => ({
            label: t(ecotaxZone.nameKey, {
              defaultValue: ecotaxZone.name, // fallback if key is not found in loco
            }),
            value: ecotaxZone.id,
          }))}
          isClearable={isClearable}
          isDisabled={readOnly}
          required={required}
        />
      )}
    </>
  );
};
